import { LabeledPasswordInput, LabeledTextInput } from '../../../generic';
import Flex from '../../../generic/Flex';
import type { GitAuth, GitTokenAuth, GitUserPasswordAuth } from '../../../../../typings/auth';

type GitDisplayNameInputProps = { auth: GitAuth; update: (_: GitAuth) => void };

export const GitDisplayNameInput = ({ auth, update }: GitDisplayNameInputProps) => (
  <LabeledTextInput
    size="small"
    label="Name (optional)"
    value={auth.displayName || ''}
    onChange={(newValue) => {
      update({
        ...auth,
        displayName: newValue,
      });
    }}
  />
);

export const GitTokenAuthInput = (props: { auth: GitTokenAuth; update: (_: GitTokenAuth) => void }) => (
  <LabeledPasswordInput
    size="small"
    label="Access Token"
    value={props.auth.hasToken ? '••••••••' : props.auth.value?.value || ''}
    onChange={(newValue) => {
      props.update({
        ...props.auth,
        value: {
          __type: 's',
          value: newValue,
        },
        hasToken: false,
      });
    }}
    isDisabled={props.auth.hasToken}
  />
);

export const GitUserPasswordAuthInputs = (props: {
  auth: GitUserPasswordAuth;
  update: (_: GitUserPasswordAuth) => void;
}) => (
  <div style={{ flexGrow: 1 }}>
    <Flex justify="space-between" gap="12px">
      <LabeledTextInput
        size="small"
        label="Username"
        value={props.auth.username}
        onChange={(newValue) => {
          props.update({ ...props.auth, username: newValue });
        }}
      />
      <LabeledPasswordInput
        size="small"
        label="Password"
        value={props.auth.hasPassword ? '••••••••' : props.auth.password?.value || ''}
        onChange={(newValue) => {
          props.update({
            ...props.auth,
            password: {
              __type: 's',
              value: newValue,
            },
            hasPassword: false,
          });
        }}
        isDisabled={props.auth.hasPassword}
      />
    </Flex>
  </div>
);
